<template>
  <div class="predefined cancel">
    <p><strong>Anfrage erhalten</strong></p>
    <ModalItem
      v-model="showModal"
      title="Wählen Sie den Grund"
      wrapper-class="modal-wrapper"
      :modal-class="`modal modal-md oeamtc`"
    >
      <oeamtc-modal
        class="cancel-modal"
        aria-describedby="dialog1_desc"
        :showCloseOption="false"
      >
        <template slot="headlineSlot">
          <template v-if="cancelReasons.length > 0"
            >Wählen Sie den Grund</template
          >
          <template v-else>Stornieren</template>
          <oeamtc-button
            tag="button"
            :round="true"
            :muted="true"
            @click="cancel()"
          >
            <svg
              height="16"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
              class=""
            >
              <path
                d="M24.573 24.577c.562-.573.562-1.51.011-2.06l-6.511-6.511 6.511-6.523a1.47 1.47 0 00-.01-2.06c-.563-.562-1.51-.562-2.061-.011L16 13.923 9.48 7.412c-.529-.54-1.498-.562-2.06.01-.562.563-.551 1.532-.011 2.061l6.511 6.523-6.511 6.51c-.54.54-.551 1.5.01 2.061.574.562 1.532.551 2.061.022l6.522-6.522 6.512 6.511c.55.551 1.498.551 2.06-.01z"
              ></path>
            </svg>
          </oeamtc-button>
        </template>
        <template slot="contentSlot">
          <div
            class="oeamtc-modal__content oeamtc-panel__indent"
            id="dialog1_desc"
          >
            <template v-if="cancelReasons.length > 0">
              <div class="button-wrapper">
                <oeamtc-button
                  tag="button"
                  v-for="reason in cancelReasons"
                  :key="reason.id"
                  @click="cancel(reason)"
                  :disabled="submitDisabled"
                >
                  {{ reason.title }}
                </oeamtc-button>
              </div>
            </template>
            <template v-else>
              Um diesen Fall zu stornieren, kontaktieren Sie bitte den ÖAMTC.
              <div class="modal-footer">
                <oeamtc-button
                  tag="button"
                  class="oeamtc-button--neutral"
                  @click="cancel()"
                >
                  Abbrechen
                </oeamtc-button>
                <oeamtc-button tag="button" @click="contact()">
                  Kontaktieren
                </oeamtc-button>
              </div>
            </template>
          </div>
        </template>
      </oeamtc-modal>
    </ModalItem>
    <p>
      Die Anfrage für Pannenhilfe ist bei uns eingelangt. Die Organisation der
      Leistung wird vorbereitet. Falls Sie doch keine Hilfe mehr benötigen,
      können Sie hier stornieren:
    </p>
    <p>
      <oeamtc-button
        tag="button"
        class="oeamtc-button--neutral"
        @click="showModal = true"
      >
        Stornieren
      </oeamtc-button>
    </p>
  </div>
</template>

<script>
import axios from 'axios';
import { OeamtcButton, OeamtcModal } from '@oeamtc/styleguide-vuejs-lib-ui';

export default {
  name: 'CancelItem',
  props: ['reasons', 'token'],
  data() {
    return {
      showModal: false,
      submitDisabled: false,
      cancelReasons: [],
    };
  },
  components: {
    OeamtcButton,
    OeamtcModal,
  },
  methods: {
    cancel(reason) {
      if (reason) {
        this.submitDisabled = true;
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/msg/assistance/incident/${this.token}/cancel`,
            {
              cancel: {
                cancel_reason: reason.id,
              },
            }
          )
          .then(
            () => {
              this.submitDisabled = false;
              this.showModal = false;
              setTimeout(() => {
                this.cancelReasons = [];
              }, 500);
            },
            (error) => {
              console.error(error);
              this.submitDisabled = false;
            }
          );
      } else {
        this.showModal = false;
      }
    },
    contact() {
      window.open('https://www.oeamtc.at/kontakt/');
    },
    init() {
      this.cancelReasons = this.reasons;
    },
  },
  watch: {
    reasons: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.cancelReasons = newVal;
        }
      },
    },
  },
};
</script>

<style lang="scss">
.cancel-modal {
  .button-wrapper {
    display: flex;
    flex-direction: column;

    button {
      margin: 5px 0;
    }
  }

  .modal-footer {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: flex-end;
  }

  &.oeamtc-modal.oeamtc-panel {
    margin-bottom: 0;

    .oeamtc-panel__indent.oeamtc-panel__indent--small {
      margin-right: 0;
    }

    .oeamtc-modal__close {
      display: none;
    }

    h3 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-right: 0;

      button {
        border: 0;
      }
    }
  }
}
</style>
